// Takvimdeki vizitleri projesine göre ayırt etmek için kategorik renk atama.
//
// Takvim çipinde iki ayrı bilgi var:
//   - DURUM (tamamlandı / devam ediyor / gecikti)  → çipin zemini
//   - PROJE (kimlik)                               → çipin sol kenar şeridi
// İki kanal ayrı tutulur; aynı renk hem durum hem kimlik anlatmaz.
//
// Renk tek başına kimlik taşımaz: çipte proje kısa adı da yazar ve takvimin
// üstünde renk-proje eşlemesini gösteren bir açıklama şeridi bulunur.
//
// Slot sayısı üçle sınırlı. Takvimde çipler herhangi bir sırayla yan yana
// gelebildiği için renkler "tüm ikililer" ölçütüyle doğrulandı; doğrulanmış
// paletin ilk üç rengi bu ölçütü geçiyor, dördüncüden sonrası geçmiyor.
// Üçten fazla proje varsa fazlası nötr şeride ("Diğer") düşer ve ayrım
// metinden okunur.

export const PROJECT_COLOR_SLOTS = 3;

/** Nötr şerit: renk slotu kalmayan projeler. */
export const NEUTRAL_SLOT = 0;

/**
 * Projelere kalıcı renk slotu dağıtır.
 *
 * Slot, projenin kimliğine bağlıdır; ekrandaki sıraya veya o ay kaç proje
 * göründüğüne değil. Böylece ay değiştirildiğinde ya da bir proje listeden
 * düştüğünde kalanların rengi değişmez.
 *
 * @param {Array<{id: string}>} projects
 * @returns {Map<string, number>} projectId → slot (1..3, yoksa 0)
 */
export const buildProjectSlotMap = (projects = []) => {
  const ids = [...new Set(projects.map((p) => p?.id).filter(Boolean))].sort();
  const map = new Map();
  ids.forEach((id, index) => {
    map.set(id, index < PROJECT_COLOR_SLOTS ? index + 1 : NEUTRAL_SLOT);
  });
  return map;
};

/** Bir projenin slotu (bilinmiyorsa nötr). */
export const projectSlotOf = (slotMap, projectId) =>
  (projectId && slotMap?.get(projectId)) || NEUTRAL_SLOT;

/**
 * Açıklama şeridinde gösterilecek satırlar: yalnızca o an takvimde görünen
 * projeler listelenir, slot sırasına göre.
 *
 * @param {Array} visibleProjectIds takvimde vizit'i olan proje kimlikleri
 * @param {Map} slotMap buildProjectSlotMap sonucu
 * @param {Map} nameById projectId → görünen ad
 */
export const buildProjectLegend = (visibleProjectIds = [], slotMap, nameById) => {
  const unique = [...new Set(visibleProjectIds.filter(Boolean))];
  return unique
    .map((id) => ({
      id,
      slot: projectSlotOf(slotMap, id),
      name: nameById?.get(id) || 'Proje',
    }))
    .sort((a, b) => {
      // Renkli projeler slot sırasına göre önce, nötr olanlar adına göre sonra
      if (a.slot !== b.slot) {
        if (a.slot === NEUTRAL_SLOT) return 1;
        if (b.slot === NEUTRAL_SLOT) return -1;
        return a.slot - b.slot;
      }
      return a.name.localeCompare(b.name, 'tr');
    });
};
